import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InputField from './InputField';
import { LoadingButton } from '@mui/lab';

export default function JobGroupEditAdd({
  open,
  mode, // 'add' | 'edit'
  initialValue,
  onSave,
  onClose,
  onDelete,
  saveLoading
}) {
  const [title, setTitle] = useState(initialValue?.name || '');

  useEffect(() => {
    setTitle(initialValue?.name || '');
  }, [initialValue, open]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 1 }}>
        <DialogTitle sx={{ flex: 1 }}>
          {mode === 'add' ? 'Add Contact Group' : 'Edit Contact Group'}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
            mt: 1,
            mr: 1
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent>
        <InputField
          label="Contact"
          backgroundColor="#fff"
          value={title}
          type="number"
          onChange={(e) => setTitle(e.target.value)}
          required
        />
      </DialogContent>
      <DialogActions sx={{ pb: 2, pr: 3, pt: 0 }}>
        {/* {mode == 'edit' && (
          <LoadingButton
            variant="outlined"
            style={{
              width: 60,
              borderRadius: 5,
              letterSpacing: 0.5,
              boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
              transition: 'width 0.3s ease'
            }}
            height={30}
            fontSize={12}
            onClick={onDelete}
          >
            Delete
          </LoadingButton>
        )} */}

        <LoadingButton
          variant="contained"
          loading={saveLoading}
          style={{
            width: 70,
            borderRadius: 5,
            letterSpacing: 0.5,
            boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
            transition: 'width 0.3s ease'
          }}
          height={30}
          fontSize={12}
          onClick={() =>
            onSave({
              id: initialValue?.id,
              name: title
            })
          }
        >
          {mode === 'add' ? 'Save' : 'Update'}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
